import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const ChevronUpIcon: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="chevron up icon">
      {/* <title>chevron up icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5931 7.02546C9.82716 6.82485 10.1725 6.82485 10.4066 7.02546L16.2399 12.0255C16.502 12.2501 16.5324 12.6447 16.3077 12.9067C16.0831 13.1688 15.6885 13.1992 15.4264 12.9745L9.99985 8.32317L4.57326 12.9745C4.31118 13.1992 3.91662 13.1688 3.69198 12.9067C3.46734 12.6447 3.49769 12.2501 3.75977 12.0255L9.5931 7.02546Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default ChevronUpIcon;
